package com.narbase.letsgo.web.views.mobileUpdate

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.web.dto.config.MobileUpdateConfigDto
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.mobileupdate.GetMobileUpdateConfigEndpoint
import com.narbase.letsgo.web.routing.domain.admin.mobileupdate.UpsertMobileUpdateConfigEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class MobileUpdateManagementViewModel {

    val upsertUiState = Observable<BasicUiState>()
    val getConfigUiState = Observable<BasicUiState>()

    var config: MobileUpdateConfigDto? = null

    fun getConfig() {
        setUpsertUiStateToNull()
        basicNetworkCall(getConfigUiState) {
            val dto = GetMobileUpdateConfigEndpoint.Request()
            val response = GetMobileUpdateConfigEndpoint.remoteProcess(dto).data
            config = response.config
        }
    }

    fun upsertConfig(config: MobileUpdateConfigDto) {
        basicNetworkCall(upsertUiState) {
            val dto = UpsertMobileUpdateConfigEndpoint.Request(config)
            UpsertMobileUpdateConfigEndpoint.remoteProcess(dto).data
        }
    }

    fun setUpsertUiStateToNull() {
        upsertUiState.value = null
    }
}
